export const TIME_1S = 1000;
const TIME_1M = TIME_1S * 60;
export const TIME_10M = TIME_1M * 10;
export const TIME_1H = TIME_1M * 60;
export const TIME_24H = TIME_1H * 24;
export const TIME_1Y = 31536000 * 1000;
